// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/dashboard.scss
// module id = 2
// module chunks = 0